import React from 'react';
import { motion } from 'framer-motion';
import useScrollReveal from '../hooks/useScrollReveal';

const skillCategories = [
  {
    category: 'Frontend',
    skills: [
      { name: 'HTML / CSS', level: 90 },
      { name: 'JavaScript', level: 90 },
      { name: 'React JS', level: 80 },
      { name: 'Vue JS', level: 80 },
      { name: 'Next.js', level: 75 },
    ],
  },
  {
    category: 'Backend',
    skills: [
      { name: 'Java', level: 90 },
      { name: 'Spring Boot', level: 80 },
      { name: 'Golang', level: 70 },
      { name: 'Gin Golang', level: 70 },
    ],
  },
  {
    category: 'Mobile',
    skills: [{ name: 'Native Android', level: 80 }],
  },
];

const ProgressBar = ({ level, inView }) => (
  <div className="h-2 bg-[var(--bg-tertiary)] rounded-full overflow-hidden">
    <motion.div
      className="h-full bg-accent rounded-full"
      initial={{ width: 0 }}
      animate={inView ? { width: `${level}%` } : { width: 0 }}
      transition={{ duration: 1, ease: 'easeOut', delay: 0.2 }}
    />
  </div>
);

const Skills = () => {
  const { ref, inView } = useScrollReveal({ threshold: 0.1 });

  return (
    <section id="skills" className="section-padding bg-[var(--bg-primary)]">
      <div className="container-tight">
        <motion.div
          ref={ref}
          initial={{ opacity: 0, y: 40 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6, ease: 'easeOut' }}
        >
          <h2 className="section-heading accent-underline inline-block mb-12">
            Skills
          </h2>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {skillCategories.map((cat) => (
              <div
                key={cat.category}
                className="bg-[var(--bg-secondary)] border border-[var(--border)] rounded-2xl p-6 hover:shadow-lg hover:-translate-y-1 transition-all duration-300"
              >
                <h3 className="text-lg font-semibold text-[var(--text-primary)] mb-5 pb-3 border-b border-[var(--border)]">
                  {cat.category}
                </h3>
                <div className="space-y-5">
                  {cat.skills.map((skill) => (
                    <div key={skill.name}>
                      <div className="flex justify-between items-center mb-2 text-sm">
                        <span className="font-medium text-[var(--text-primary)]">
                          {skill.name}
                        </span>
                        <span className="font-mono text-accent text-xs font-semibold">
                          {skill.level}%
                        </span>
                      </div>
                      <ProgressBar level={skill.level} inView={inView} />
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Skills;
